import { superficieDestino } from './../../../models/superficieDestino.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-superficie-destino',
  templateUrl: './superficie-destino.component.html',
  styleUrls: ['./superficie-destino.component.css'],
  providers: [FormService]
})
export class SuperficieDestinoComponent {

  @ViewChild('openModal') openModal: TemplateRef<any>;
  public rows = [];
  public actualRow;
  public superficieDestino: superficieDestino;
  public form;
  public idForm;

  public form131;

  public form12;
  public form13;
  public form14;
  
  public form231
  public form232
  public form233
  public form234 
  public form235 

  public form251;
  public form252;
  public form253;
  public form254;
  public form255;

  public matcher = new FormService();

  constructor(private fb: FormBuilder, private dialog: MatDialog) {
      this.idForm = localStorage.getItem("form");

      if (this.idForm == "1-3.1") {
        this.form131 = true
      }

      if (this.idForm == "2-5.1") {
        this.form251 = true;
      }
      if (this.idForm == "2-5.2") {
        this.form252 = true;
      }
      if (this.idForm == "2-5.3") {
        this.form253 = true;
      }
      if (this.idForm == "2-5.4") {
        this.form254 = true;
      }
      if (this.idForm == "2-5.5") {
        this.form255 = true;
      }

      this.form = new FormGroup({
          residencial: new FormControl(0),
          equipamiento: new FormControl(0),
          actProductivas: new FormControl(0),
          infraestructura: new FormControl(0),
          areaVerde: new FormControl(0),
          espacioPublico: new FormControl(0),

          residencialMod: new FormControl(0),
          equipamientoMod: new FormControl(0),
          actProductivasMod: new FormControl(0),
          infraestructuraMod: new FormControl(0),
          areaVerdeMod: new FormControl(0),
          espacioPublicoMod: new FormControl(0),
      })

      if (!JSON.parse(localStorage.getItem("superficieDestino"))) {
          localStorage.setItem("superficieDestino", JSON.stringify(this.rows));
      } else {
          this.rows = JSON.parse(localStorage.getItem("superficieDestino"));
       
          this.form.controls['residencial'].setValue(this.rows[0] ? this.rows[0].residencial : 0)
          this.form.controls['equipamiento'].setValue(this.rows[0] ? this.rows[0].equipamiento : 0)
          this.form.controls['actProductivas'].setValue(this.rows[0] ? this.rows[0].actProductivas : 0)
          this.form.controls['infraestructura'].setValue(this.rows[0] ? this.rows[0].infraestructura : 0)
          this.form.controls['areaVerde'].setValue(this.rows[0] ? this.rows[0].areaVerde : 0)
          this.form.controls['espacioPublico'].setValue(this.rows[0] ? this.rows[0].espacioPublico : 0)
       
          this.form.controls['residencialMod'].setValue(this.rows[0] ? this.rows[0].residencialMod : 0)
          this.form.controls['equipamientoMod'].setValue(this.rows[0] ? this.rows[0].equipamientoMod : 0)
          this.form.controls['actProductivasMod'].setValue(this.rows[0] ? this.rows[0].actProductivasMod : 0)
          this.form.controls['infraestructuraMod'].setValue(this.rows[0] ? this.rows[0].infraestructuraMod : 0)
          this.form.controls['areaVerdeMod'].setValue(this.rows[0] ? this.rows[0].areaVerdeMod : 0)
          this.form.controls['espacioPublicoMod'].setValue(this.rows[0] ? this.rows[0].espacioPublicoMod : 0)
    
      }

      this.superficieDestino = {
        residencial: 0,
        equipamiento: 0,
        actProductivas: 0,
        infraestructura: 0,
        areaVerde: 0,
        espacioPublico: 0,

        residencialMod: 0,
        equipamientoMod: 0,
        actProductivasMod: 0,
        infraestructuraMod: 0,
        areaVerdeMod: 0,
        espacioPublicoMod: 0
    
      };


  }

  add_superficieDestino() {
      localStorage.setItem("superficieDestino", JSON.stringify([]));
      this.actualRow = localStorage.getItem("superficieDestino");
      this.rows = JSON.parse(this.actualRow);
      this.rows = this.rows.concat({
        residencial: this.form.value.residencial,
        equipamiento: this.form.value.equipamiento,
        actProductivas: this.form.value.actProductivas,
        infraestructura: this.form.value.infraestructura,
        areaVerde: this.form.value.areaVerde,
        espacioPublico: this.form.value.espacioPublico,

        residencialMod: this.form.value.residencialMod,
        equipamientoMod: this.form.value.equipamientoMod,
        actProductivasMod: this.form.value.actProductivasMod,
        infraestructuraMod: this.form.value.infraestructuraMod,
        areaVerdeMod: this.form.value.areaVerdeMod,
        espacioPublicoMod: this.form.value.espacioPublicoMod,
      

      })
      localStorage.setItem("superficieDestino", JSON.stringify(this.rows));


  }
  delete_superficieDestino(id) {
      for (let x = 0; x < this.rows.length; x++) {
          if (id == x) {
              this.rows.splice(x, 1);
              localStorage.setItem("superficieDestino", JSON.stringify(this.rows));
          }
      }
  }


}
